//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { IPromotedPostsReachEstimateState } from '../models/AppState';
import {
    PROMOTED_POSTS_REACH_ESTIMATE_ACTIONS,
} from '../promoted-posts-constants/promoted-posts-reach-estimate-constants';

const initialState: IPromotedPostsReachEstimateState = {
  reachEstimate: null,
  rawReachEstimate: null,
  isFetchingReachEstimate: false,
  isValid: false,
};

export default function PromotedPostsReachEstimateReducer(state = initialState, action) {
  switch (action.type) {
    case PROMOTED_POSTS_REACH_ESTIMATE_ACTIONS.CLEAR_PROMOTED_POSTS_REACH_ESTIMATE_STATE:
      return initialState;
    case PROMOTED_POSTS_REACH_ESTIMATE_ACTIONS.REQUEST_REACH_ESTIMATE:
      return {
        ...state,
        isFetchingReachEstimate: true,
      };
    case PROMOTED_POSTS_REACH_ESTIMATE_ACTIONS.RECEIVE_REACH_ESTIMATE:
      return {
        ...state,
        reachEstimate: action.payload.reachEstimate,
        rawReachEstimate: action.payload.rawReachEstimate,
        isValid: action.payload.isValid,
        isFetchingReachEstimate: false,
      };
    default:
      return state;
  }
}
